import type { ShortcutButtonProps } from "@sb1/ffe-buttons-react";
import type { ElementType } from "react";
import { getCustomData } from "~/utils/tracking/utils";
import { ShortcutButton as FellesShortcutButton } from "@sb1f/buttons";

type Props<As extends ElementType = "button"> = ShortcutButtonProps<As> & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const ShortcutButton = <As extends ElementType = "button">({ track = true, trackingData, ...props }: Props<As>) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesShortcutButton customData={customData} {...(props as any)} />;
};

export default ShortcutButton;
